import React from 'react'

export default function ErrorFallback({ error, opts }) {
  return (
    <div role="alert" className="py-6">
      <div role="alert" className="bg-orange-200">
        <div>名称: {opts.title}</div>
        <div>渲染类型: {opts.type}</div>
        <div>slug: {opts.slug}</div>
        <div>描述: {opts.hint}</div>
        <pre>{error.message}</pre>
      </div>
    </div>
  )
}
